import { render } from "./CreateEditPrazeDraw.vue?vue&type=template&id=6b9a74b9"
import script from "./CreateEditPrazeDraw.vue?vue&type=script&lang=js"
export * from "./CreateEditPrazeDraw.vue?vue&type=script&lang=js"

import "./CreateEditPrazeDraw.vue?vue&type=style&index=0&id=6b9a74b9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__